// Fetch Orders
export const FETCH_PRODUCTION_ORDERS = "FETCH_PRODUCTION_ORDERS"
export const FETCH_PRODUCTION_ORDERS_SUCCESS = "FETCH_PRODUCTION_ORDERS_SUCCESS"
export const FETCH_PRODUCTION_ORDERS_FAIL = "FETCH_PRODUCTION_ORDERS_FAIL"

// Fetch Tasks
export const FETCH_PRODUCTION_TASKS = "FETCH_PRODUCTION_TASKS"
export const FETCH_PRODUCTION_TASKS_SUCCESS = "FETCH_PRODUCTION_TASKS_SUCCESS"
export const FETCH_PRODUCTION_TASKS_FAIL = "FETCH_PRODUCTION_TASKS_FAIL"

// Update Order Status
export const UPDATE_ORDER_STATUS = "UPDATE_ORDER_STATUS"
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS"
export const UPDATE_ORDER_STATUS_FAIL = "UPDATE_ORDER_STATUS_FAIL"

// Bulk Update Orders
export const BULK_UPDATE_ORDERS = "BULK_UPDATE_ORDERS"
export const BULK_UPDATE_ORDERS_SUCCESS = "BULK_UPDATE_ORDERS_SUCCESS"
export const BULK_UPDATE_ORDERS_FAIL = "BULK_UPDATE_ORDERS_FAIL"

// Clear cache
export const CLEAR_PRODUCTION_CACHE = "CLEAR_PRODUCTION_CACHE"

// Set filter
export const SET_PRODUCTION_FILTER = "SET_PRODUCTION_FILTER"
